import type { AppsConfig } from "../../../lib/remote-config";
import type { GetOneUsdActionId } from "../types";

export type GetOneUsdRemoteModes = NonNullable<
  NonNullable<AppsConfig["getOneUsd"]>["modes"]
>;

const REMOTE_MODE_KEYS: Record<
  GetOneUsdActionId,
  keyof GetOneUsdRemoteModes
> = {
  swap: "swap",
  bridge: "bridge",
  transfer: "transferCrypto",
};

/**
 * Swap/Bridge stay enabled when config is unavailable. Transfer Crypto is
 * opt-in and stays hidden until S3 explicitly enables it.
 */
export function isGetOneUsdActionEnabled(
  action: GetOneUsdActionId,
  modes?: GetOneUsdRemoteModes,
): boolean {
  const configured = modes?.[REMOTE_MODE_KEYS[action]];
  return configured ?? action !== "transfer";
}
